// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-pages-admin-operation-manage-index-container"};